import { render } from "./ImageCount.vue?vue&type=template&id=034998b4&ts=true"
import script from "./ImageCount.vue?vue&type=script&lang=ts"
export * from "./ImageCount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__